export default __webpack_public_path__ + "static/media/Ruthless Blade.a3100794.jpg";